import React from "react";

import "./ErrorBoundary.css";

type ErrorBoundaryProps = {
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
  error: Error | null;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      return (
        <div className="eb-fallback">
          <div className="eb-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <circle cx="24" cy="24" r="22" stroke="rgba(207,141,168,0.4)" strokeWidth="2" />
              <path d="M24 14v12" stroke="rgba(207,141,168,0.7)" strokeWidth="2.5" strokeLinecap="round" />
              <circle cx="24" cy="32" r="1.5" fill="rgba(207,141,168,0.7)" />
            </svg>
          </div>
          <h2 className="eb-title">Something went wrong</h2>
          <p className="eb-message">{this.state.error?.message}</p>
          <button
            className="eb-retry"
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            Try again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
